import { useEffect, useRef } from 'react';
import type { RootState } from '@store/root-reducer';

type SdkOptions = NonNullable<RootState['docsVerification']['sdkOptions']>;

type UseFinishInitParams = {
    onFinish?: () => void | Promise<void>;
    isCustomPartner?: boolean;
    isInDashboard: boolean;
    sdkOptions?: SdkOptions;
    startRedirectTimer: () => void;
};

export const useFinishInit = ({
    onFinish,
    isCustomPartner,
    isInDashboard,
    sdkOptions,
    startRedirectTimer,
}: UseFinishInitParams) => {
    const isFinished = useRef(false);

    useEffect(() => {
        const handleFinish = async () => {
            if (onFinish) {
                await onFinish();
            }

            if (
                isInDashboard &&
                ((sdkOptions?.redirectUrl &&
                    !sdkOptions?.settings?.finish_screen_settings?.enabled) ||
                    (sdkOptions?.settings?.finish_screen_settings?.enabled &&
                        sdkOptions?.settings?.finish_screen_settings?.redirect_link &&
                        sdkOptions?.settings?.finish_screen_settings?.redirect_warning))
            ) {
                startRedirectTimer();
            }
        };

        if (!isCustomPartner && !isFinished.current) {
            isFinished.current = true;
            handleFinish();
        }
    }, [sdkOptions, onFinish, startRedirectTimer, isCustomPartner, isInDashboard]);
};
